<template>
    <div class="main" >
        <div class="wrapper"  v-loading="loading">
            <div
                style="margin:calc(100vh/3) auto ; background-color: #fff; width: 350px; height: 310px; padding: 20px;;box-shadow: 0 0  20px #cac6c6;border-radius: 5px">

                <div style="margin: 5px 0 20px 0; text-align: center; font-size: 16px;text-align: center;color: #1d3152 !important;" >
                    🔐羲和太阳能管理平台
                </div>

                <hr style="border: 0;height: 1px;background-color: #e6e6e7;">

                <el-form :model="user" :rules="rules" ref="userForm" style="margin-top: 20px">
                    <el-form-item prop="username">
                        <el-input size="medium" style="margin: 10px 0" prefix-icon="el-icon-user" placeholder="请输入11位手机号"
                                  v-model="user.username"></el-input>
                    </el-form-item>
                    <el-form-item prop="password">
                        <el-input size="medium" style="margin: 10px 0" prefix-icon="el-icon-lock" placeholder="请输入密码"
                                  show-password v-model="user.password"></el-input>
                    </el-form-item>
                    <el-form-item style="margin: 30px 0; text-align: center">
                        <!--          <el-button type="success" size="small" round autocomplete="off" @click="$router.push('/register')">注册</el-button>-->
                        <el-button size="small" autocomplete="off" style="width: 100%;height: 40px;"   type="primary"
                                   @click="login">登录
                        </el-button>
                    </el-form-item>

                    <div v-if="false" class="el-" style="margin: 5px 0 20px 0; text-align: right; font-size: 14px;color: white;">

                        <el-link href="visitor" underline type="success" target="_blank">游客模式</el-link>
                    </div>
                </el-form>
            </div>
        </div>

<!--        <el-footer style="text-align: center;line-height: 60px;">
            Copyright © 2022
        </el-footer>-->
    </div>
</template>

<script>
import {setRoutes} from "@/router";
import Foot from "@/components/Foot";

export default {
    name: "Login",
    components: {Foot},
    data() {
        return {
            loading:false,
            user: {},
            rules: {
                username: [
                    {required: true, message: '请输入11位手机号码', trigger: 'blur'},
                    {min: 11, max: 11, message: '请输入11位手机号码', trigger: 'blur'}

                ],
                password: [
                    {required: true, message: '请输入密码', trigger: 'blur'},
                    {min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur'}
                ],
            }
        }
    },
    methods: {
        login() {
            this.$refs['userForm'].validate((valid) => {
                if (valid) {  // 表单校验合法
                    this.loading = true
                    this.request.post("/user/login", this.user).then(res => {
                        this.loading = false
                        if (res.code === '200') {
                            localStorage.setItem("user", JSON.stringify(res.data))  // 存储用户信息到浏览器
                            localStorage.setItem("menus", JSON.stringify(res.data.menus))  // 存储用户信息到浏览器

                            // 动态设置当前用户的路由
                            setRoutes()
                            this.$router.push("/show_")
                            this.$message.success("登录成功")
                        } else {
                            this.$message.error(res.msg)
                        }
                    })
                }
            });
        }
    }
}
</script>

<style>
.main {
    height:  calc(100vh);
    background-image: linear-gradient(180deg, #2af598 0%, #009efd 100%);

    overflow: hidden;
}
/*.main{
    background-image: url("../assets/login.jpg");
}*/
/*.main{background:#010e50 url(../assets/login.jpg) center top no-repeat;background-size:100% auto}*/
</style>
